import { gql } from 'apollo-angular';

export const benchmarkSelectByQuery = gql`
  query BenchmarkSelectBy {
    benchmarkSelectBy {
      id
      name
      categories {
        id
        name
      }
    }
  }
`;

export const benchmarkCategoryListQuery = gql`
  query BenchmarkCategoryList($benchmarkId: ID!, $categoryId: ID) {
    benchmarkCategoryList(benchmarkId: $benchmarkId, categoryId: $categoryId) {
      id
      name
      benchmarkId
      categoryId
    }
  }
`;

export const benchmarkMetricListQuery = gql`
  query BenchmarkMetricList($benchmarkId: ID!, $categoryId: ID) {
    benchmarkMetricList(benchmarkId: $benchmarkId, categoryId: $categoryId) {
      id
      name
    }
  }
`;

export const benchmarkExportQuery = gql`
  query BenchmarkExport(
    $benchmark: String!,
    $categoryId: String!,
    $benchmarkCategory: [String]!, 
    $metric: String!, 
    $fromTs: AWSDateTime!, 
    $toTs: AWSDateTime!,
    $resolution: String!
  ){
    benchmarkExport(
      benchmark: $benchmark
      categoryId: $categoryId
      benchmarkCategory: $benchmarkCategory
      metric: $metric
      fromTs: $fromTs
      toTs: $toTs
      resolution: $resolution
    ) {
      id
      filename
      contentType
      size
      content
    }
  }
`;

export const benchmarkDataChartQuery = gql`
  query BenchmarkDataChart(
    $benchmarkId: ID!
    $categoryId: ID
    $benchmarkCategoryIds: [ID!]!
    $metricId: ID!
    $fromTs: AWSDateTime!
    $toTs: AWSDateTime!
    $resolutionId: ID
  ) {
    benchmarkDataChart(
      benchmarkId: $benchmarkId
      categoryId: $categoryId
      benchmarkCategoryIds: $benchmarkCategoryIds
      metricId: $metricId
      fromTs: $fromTs
      toTs: $toTs
      resolutionId: $resolutionId
    ) {
      yValues {
        label
        data
      }
      xValues
    }
  }
`;

export const benchmarkResolutionListQuery = gql`
  query BenchmarkResolutionList {
    benchmarkResolutionList {
      id
      name
    }
  }
`;
